import React from 'react'
import styled from 'styled-components'

import AuthToken from './AuthToken'
import AppleIcon from '../../icons/AppleIcon'
import { LoginSocial } from '../styles'

const AppleSignInButton = styled(LoginSocial)`
  color: #444444;
  border: 1px solid #888888;
  margin-bottom: 10px;
  padding: 0;

  svg {
    width: 56px;
    max-height: 56px;
    margin-right: 0;
  }
`

type AppleLoginProps = {
  children: React.ReactNode
}

const AppleLogin = ({ children }: AppleLoginProps) => (
  <form action="/omniauth/apple" method="post">
    <AuthToken />
    <AppleSignInButton type="submit" className="qa-apple-login">
      <AppleIcon />
      {children}
    </AppleSignInButton>
  </form>
)

export default AppleLogin
